// extracted by mini-css-extract-plugin
export default {"rotated":"style--rotated--2df0b5","goToBaseWrapper":"style--goToBaseWrapper--c91964","goTo":"style--goTo--e1bd4e"};